/**
 * Agent module route definitions.
 *
 * `role` is kept for backward compatibility; `permission` is the primary
 * access check used by ProtectedRoute.
 */
import React from 'react';

import AgentDashboard from './pages/AgentDashboard';
import AgentDocumentVerification from './pages/AgentDocumentVerification';
import AgentRequestManagement from './pages/AgentRequestManagement';
import AgentAnalytics from './pages/AgentAnalytics';

const agentRoutes = [
  { path: '/agent/dashboard',  element: <AgentDashboard />,             role: 'agent', permission: ['operations.leads.view', 'operations.farms.view'] },
  { path: '/agent/documents',  element: <AgentDocumentVerification />,  role: 'agent', permission: 'operations.documents' },
  { path: '/agent/requests',   element: <AgentRequestManagement />,     role: 'agent', permission: ['operations.leads.view', 'operations.leads.manage'] },
  { path: '/agent/analytics',  element: <AgentAnalytics />,             role: 'agent', permission: 'system.analytics' },
];

export default agentRoutes;
